import { TimestampQuery } from 'three/webgpu';

// How long the GPU spends on a frame, in milliseconds, read back a few frames late.
// Legacy WebGLRenderer: a timer query around each render (EXT_disjoint_timer_query_webgl2, which
// most desktop and Android Chrome builds expose; null where it is missing).
// New renderer: its own timestamp tracking (`trackTimestamp`), resolved after each frame.
export class GpuTimer {
  constructor(renderer, legacy) {
    this.renderer = renderer;
    this.legacy = legacy;
    this.ms = null;
    this.queries = [];
    this.active = null;
    if (legacy) {
      this.gl = renderer.getContext();
      this.ext = this.gl.getExtension('EXT_disjoint_timer_query_webgl2');
    }
  }

  get available() {
    return this.legacy ? !!this.ext : !!this.renderer.trackTimestamp;
  }

  begin() {
    if (!this.legacy || !this.ext || this.active) return;
    const q = this.gl.createQuery();
    this.gl.beginQuery(this.ext.TIME_ELAPSED_EXT, q);
    this.active = q;
  }

  end() {
    if (this.legacy) {
      if (!this.active) return;
      this.gl.endQuery(this.ext.TIME_ELAPSED_EXT);
      this.queries.push(this.active);
      this.active = null;
      this.poll();
    } else if (this.renderer.trackTimestamp) {
      this.renderer.resolveTimestampsAsync(TimestampQuery.RENDER).then(() => {
        const t = this.renderer.info.render.timestamp;
        if (t > 0) this.ms = t;
      });
    }
  }

  poll() {
    const gl = this.gl;
    while (this.queries.length) {
      const q = this.queries[0];
      if (!gl.getQueryParameter(q, gl.QUERY_RESULT_AVAILABLE)) break;
      this.queries.shift();
      if (!gl.getParameter(this.ext.GPU_DISJOINT_EXT)) this.ms = gl.getQueryParameter(q, gl.QUERY_RESULT) / 1e6;
      gl.deleteQuery(q);
    }
  }
}
